import { getLocale } from 'umi';
import { LOCALE } from '@/utils';
import { useLocaleChange } from '.';

const LANG_MAP = {
  zh_CN: 'CN',
  en_US: 'EN',
};

type LangKey = keyof typeof LANG_MAP;

/**
 * 暂时是中英文切换
 */
export const useSelectLang = () => {
  useLocaleChange();

  const locale = getLocale();

  const setLocale = (key: string) => {
    LOCALE.setLocale(key);
  };

  const changeLang = () => {
    if (locale === 'zh_CN') setLocale('en_US');
    if (locale === 'en_US') setLocale('zh_CN');
    if (location.pathname === '/login') {
      location.reload();
      return;
    }
    location.href = '/';
  };

  return {
    lang: LANG_MAP[locale as LangKey],
    changeLang,
  };
};
